"use client";
import React from "react";
import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import PocCloudTabs from "@/components/pageTabs/pocCloudTabs";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import FeaturesComponent from "./components/features";
import ServicesComponent from "./components/services";

const NetworkAutomationPage = () => {
  return (
    <Box>
      <Hero />
      <PageLayout showContactForm>
        <PocCloudTabs />
        <Intro />
        <FeaturesComponent />
        <ServicesComponent />
        <Faqs />
      </PageLayout>
    </Box>
  );
};

export default NetworkAutomationPage;
